"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
/**
 * Set optional global default values
 */
var AdsenseConfig = (function () {
    function AdsenseConfig(config) {
        if (config === void 0) { config = {}; }
        this.adClient = config.adClient || this.adClient;
        this.adSlot = config.adSlot || this.adSlot;
        this.adFormat = config.adFormat || this.adFormat;
        this.display = config.display || 'block';
        this.width = config.width;
        this.height = config.height;
    }
    return AdsenseConfig;
}());
exports.AdsenseConfig = AdsenseConfig;
var AdsenseComponent = (function () {
    function AdsenseComponent(config) {
        this.config = config;
        this.adFormat = 'auto';
        /** can be manually set if you need all ads on a page to have same id page-xxx */
        this.adRegion = 'page-' + Math.floor(Math.random() * 10000) + 1;
    }
    AdsenseComponent.prototype.ngOnInit = function () {
        this.adClient = this.adClient || this.config.adClient;
        this.adSlot = this.adSlot || this.config.adSlot;
        this.adFormat = this.adFormat || this.config.adFormat;
        this.display = this.display || this.config.display;
        this.width = this.width || this.config.width;
        this.height = this.height || this.config.height;
    };
    /**
     * attempts to push the ad twice. Usually if one doesn't work the other
     * will depeding on if the browser has the adsense code cached and
     * if its the first page to be loaded
     */
    AdsenseComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        var res = this.push();
        if (res instanceof TypeError) {
            setTimeout(function () { return _this.push(); }, 200);
        }
    };
    AdsenseComponent.prototype.push = function () {
        try {
            var adsbygoogle = window['adsbygoogle'];
            adsbygoogle.push({});
            return true;
        }
        catch (e) {
            return e;
        }
    };
    return AdsenseComponent;
}());
AdsenseComponent.decorators = [
    { type: core_1.Component, args: [{
                selector: 'ng2-adsense',
                template: "\n    <div style=\"padding-bottom:8px;\">\n      <ins class=\"adsbygoogle\"\n        [ngStyle]=\"{'display': display, 'width.px': width, 'height.px': height }\"\n        [attr.data-ad-client]=\"adClient\"\n        [attr.data-ad-slot]=\"adSlot\"\n        [attr.data-ad-format]=\"adFormat\"\n        [attr.data-ad-region]=\"adRegion\">\n      </ins>\n    </div>\n  ",
            },] },
];
/** @nocollapse */
AdsenseComponent.ctorParameters = function () { return [
    { type: AdsenseConfig, },
]; };
AdsenseComponent.propDecorators = {
    'adClient': [{ type: core_1.Input },],
    'adSlot': [{ type: core_1.Input },],
    'adFormat': [{ type: core_1.Input },],
    'adRegion': [{ type: core_1.Input },],
    'display': [{ type: core_1.Input },],
    'width': [{ type: core_1.Input },],
    'height': [{ type: core_1.Input },],
};
exports.AdsenseComponent = AdsenseComponent;
exports.ADSENSE_CONFIG = new core_1.OpaqueToken('AdsenseConfig');
function provideAdsenseConfig(config) {
    return new AdsenseConfig(config);
}
exports.provideAdsenseConfig = provideAdsenseConfig;
var AdsenseModule = (function () {
    function AdsenseModule() {
    }
    AdsenseModule.forRoot = function (config) {
        return {
            ngModule: AdsenseModule,
            providers: [
                { provide: exports.ADSENSE_CONFIG, useValue: config },
                { provide: AdsenseConfig, useFactory: provideAdsenseConfig, deps: [exports.ADSENSE_CONFIG] },
            ]
        };
    };
    return AdsenseModule;
}());
AdsenseModule.decorators = [
    { type: core_1.NgModule, args: [{
                imports: [common_1.CommonModule],
                exports: [AdsenseComponent],
                declarations: [AdsenseComponent],
            },] },
];
/** @nocollapse */
AdsenseModule.ctorParameters = function () { return []; };
exports.AdsenseModule = AdsenseModule;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-adsense/ng2-adsense.js
// module id = 599
// module chunks = 0